import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/covers-&-tops")({
  beforeLoad: () => {
    throw redirect({ to: "/covers-tops", statusCode: 301 });
  },
  server: {
    handlers: {
      GET: () =>
        new Response(null, {
          status: 301,
          headers: { Location: "/covers-tops" },
        }),
    },
  },
  component: () => null,
});
